var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.879 13.879 18 9 18C4.121 18 0 13.879 0 9C0 4.121 4.121 0 9 0C13.879 0 18 4.121 18 9ZM16 9C16 5.206 12.794 2 9 2C5.206 2 2 5.206 2 9C2 12.794 5.206 16 9 16C12.794 16 16 12.794 16 9ZM10 10V5H8V10H10ZM10 13V11H8V13H10Z",
    fill: "#CF0A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.0c1309ca29c069905dda8077a3df9ac5.svg";
export { ForwardRef as ReactComponent };